import { Component, OnInit, Input } from '@angular/core';
import { NavController, AlertController, ToastController, ModalController } from '@ionic/angular';
import { Router, ActivatedRoute } from '@angular/router';
import { JavapiService } from 'src/app/services/javapi.service';
import { Modelogeneraldatos } from 'src/app/models/modelogeneraldatos';
import { AdminCrudEditModalComponent } from 'src/app/modal/admin-crud-edit-modal/admin-crud-edit-modal.component';
import { AppBarStateService } from 'src/app/services/app-bar-state.service';

@Component({
  selector: 'app-admin-crud',
  templateUrl: './admin-crud.page.html',
  styleUrls: ['./admin-crud.page.scss'],
  standalone: false,
})
export class AdminCrudPage implements OnInit {
  @Input() entity: string = '';
  @Input() autoOpenAdd: boolean = false;
  @Input() initialData: any = {};
  isModal: boolean = false;
  pageTitle: string = '';
  pageSubTitle: string = '';
  entityName: string = '';
  iconName: string = 'cube-outline';
  iconColor: string = '#3498db';
  entityLabel: string = '';

  items: Modelogeneraldatos[] = [];
  filteredItems: Modelogeneraldatos[] = [];
  searchText: string = '';
  loading: boolean = false;

  isModalOpen: boolean = false;
  isEditing: boolean = false;
  currentData: any = {};
  entityFields: any[] = [];

  // Auxiliary data for selects
  clients: Modelogeneraldatos[] = [];
  groups: Modelogeneraldatos[] = [];
  regions: Modelogeneraldatos[] = [];
  solicitors: Modelogeneraldatos[] = [];
  rawSolicitorsList: Modelogeneraldatos[] = [];
  roles: Modelogeneraldatos[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private javapi: JavapiService,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    private modalCtrl: ModalController,
    private navCtrl: NavController,
    private appBarState: AppBarStateService
  ) { }

  hasAppbar: boolean = false;

  ngOnInit() {
    this.appBarState.barVisible$.subscribe(visible => {
      this.hasAppbar = visible;
    });
    this.hasAppbar = this.appBarState.isBarVisible;

    this.isModal = !!this.entity; // If entity is passed as input, we assume it's a modal
    if (!this.entity) {
      this.detectEntity();
    } else {
      this.resolveEntityLabels(); // Manual detection logic
    }
    this.loadData();
    this.loadAuxiliaryData();

    if (this.autoOpenAdd) {
      setTimeout(() => this.openAddModal(), 500);
    }
  }

  ionViewWillEnter() {
    this.hasAppbar = this.appBarState.isBarVisible;
  }

  resolveEntityLabels() {
    switch (this.entity) {
      case 'CLIENTE':
        this.pageTitle = 'Clientes';
        this.pageSubTitle = 'Gestión de empresas';
        this.entityName = 'Cliente';
        this.iconName = 'business-outline';
        this.iconColor = '#3498db';
        break;
      case 'DIRECCION':
        this.pageTitle = 'Direcciones';
        this.pageSubTitle = 'Tiendas y sucursales';
        this.entityName = 'Dirección';
        this.iconName = 'location-outline';
        this.iconColor = '#2ecc71';
        break;
      case 'SOLICITANTE':
        this.pageTitle = 'Solicitantes';
        this.pageSubTitle = 'Encargados de solicitudes';
        this.entityName = 'Solicitante';
        this.iconName = 'person-outline';
        this.iconColor = '#9b59b6';
        break;
      case 'GRUPO':
        this.pageTitle = 'Grupos';
        this.pageSubTitle = 'Pools de notificación';
        this.entityName = 'Grupo';
        this.iconName = 'mail-unread-outline';
        this.iconColor = '#e67e22';
        break;
      case 'REGION':
        this.pageTitle = 'Regiones';
        this.pageSubTitle = 'Áreas y combustible';
        this.entityName = 'Región';
        this.iconName = 'map-outline';
        this.iconColor = '#e74c3c';
        break;
      case 'TRABAJADOR':
        this.pageTitle = 'Trabajadores';
        this.pageSubTitle = 'Personal y operarios';
        this.entityName = 'Trabajador';
        this.iconName = 'construct-outline';
        this.iconColor = '#2980b9';
        break;
      case 'ROL':
        this.pageTitle = 'Roles y Costos';
        this.pageSubTitle = 'Cargos y costos por turno';
        this.entityName = 'Rol';
        this.iconName = 'briefcase-outline';
        this.iconColor = '#8e44ad';
        break;
      case 'SUBCONTRATISTA':
        this.pageTitle = 'Subcontratistas';
        this.pageSubTitle = 'Proveedores externos';
        this.entityName = 'Subcontratista';
        this.iconName = 'business-outline';
        this.iconColor = '#16a085';
        break;
      case 'ESTRUCTURA':
        this.pageTitle = 'Estructuras';
        this.pageSubTitle = 'Tipos de estructuras';
        this.entityName = 'Estructura';
        this.iconName = 'git-network-outline';
        this.iconColor = '#3498db';
        break;
      case 'AREA':
        this.pageTitle = 'Áreas';
        this.pageSubTitle = 'Áreas de trabajo en postes';
        this.entityName = 'Área';
        this.iconName = 'crop-outline';
        this.iconColor = '#2ecc71';
        break;
      case 'ACTIVIDAD':
        this.pageTitle = 'Actividades';
        this.pageSubTitle = 'Tareas y rubros operativos';
        this.entityName = 'Actividad';
        this.iconName = 'list-outline';
        this.iconColor = '#f39c12';
        break;
      case 'CANTIDAD':
        this.pageTitle = 'Cantidades';
        this.pageSubTitle = 'Opciones de cantidad (medidas)';
        this.entityName = 'Cantidad';
        this.iconName = 'calculator-outline';
        this.iconColor = '#e74c3c';
        break;
      case 'UNIDAD':
        this.pageTitle = 'Unidades';
        this.pageSubTitle = 'Unidades de medida (m, c/u, etc)';
        this.entityName = 'Unidad';
        this.iconName = 'thermometer-outline';
        this.iconColor = '#9b59b6';
        break;
      case 'PLANTILLA_OBS':
        this.pageTitle = 'Plantillas de Observación';
        this.pageSubTitle = 'Textos predefinidos para cotizaciones';
        this.entityName = 'Plantilla';
        this.iconName = 'document-text-outline';
        this.iconColor = '#2c3e50';
        break;
      case 'PLANTILLA_PAGOS':
        this.pageTitle = 'Plantillas de Pagos';
        this.pageSubTitle = 'Comentarios predefinidos para pagos';
        this.entityName = 'Plantilla';
        this.iconName = 'wallet-outline';
        this.iconColor = '#3498db';
        break;
      case 'COMERCIO':
        this.pageTitle = 'Comercios';
        this.pageSubTitle = 'Proveedores y locales de compras';
        this.entityName = 'Comercio';
        this.iconName = 'cart-outline';
        this.iconColor = '#16a085';
        break;
      case 'GASTO_CATEGORIA':
        this.pageTitle = 'Categorías de Gastos';
        this.pageSubTitle = 'Tipificación de gastos operativos';
        this.entityName = 'Categoría';
        this.iconName = 'pricetags-outline';
        this.iconColor = '#f39c12';
        break;
    }
    this.entityLabel = this.pageTitle;
  }

  detectEntity() {
    const path = this.router.url;
    if (path.includes('clientes')) {
      this.entity = 'CLIENTE';
      this.pageTitle = 'Clientes';
      this.pageSubTitle = 'Gestión de empresas';
      this.entityName = 'Cliente';
      this.iconName = 'business-outline';
      this.iconColor = '#3498db';
    } else if (path.includes('direcciones')) {
      this.entity = 'DIRECCION';
      this.pageTitle = 'Direcciones';
      this.pageSubTitle = 'Tiendas y sucursales';
      this.entityName = 'Dirección';
      this.iconName = 'location-outline';
      this.iconColor = '#2ecc71';
    } else if (path.includes('solicitantes')) {
      this.entity = 'SOLICITANTE';
      this.pageTitle = 'Solicitantes';
      this.pageSubTitle = 'Encargados de solicitudes';
      this.entityName = 'Solicitante';
      this.iconName = 'person-outline';
      this.iconColor = '#9b59b6';
    } else if (path.includes('grupos')) {
      this.entity = 'GRUPO';
      this.pageTitle = 'Grupos';
      this.pageSubTitle = 'Pools de notificación';
      this.entityName = 'Grupo';
      this.iconName = 'mail-unread-outline';
      this.iconColor = '#e67e22';
    } else if (path.includes('regiones')) {
      this.entity = 'REGION';
      this.pageTitle = 'Regiones';
      this.pageSubTitle = 'Áreas y combustible';
      this.entityName = 'Región';
      this.iconName = 'map-outline';
      this.iconColor = '#e74c3c';
    } else if (path.includes('trabajadores')) {
      this.entity = 'TRABAJADOR';
      this.pageTitle = 'Trabajadores';
      this.pageSubTitle = 'Personal y operarios';
      this.entityName = 'Trabajador';
      this.iconName = 'construct-outline';
      this.iconColor = '#2980b9';
    } else if (path.includes('roles')) {
      this.entity = 'ROL';
      this.pageTitle = 'Roles y Costos';
      this.pageSubTitle = 'Cargos y costos por turno';
      this.entityName = 'Rol';
      this.iconName = 'briefcase-outline';
      this.iconColor = '#8e44ad';
    } else if (path.includes('plantillas-obs')) {
      this.entity = 'PLANTILLA_OBS';
      this.resolveEntityLabels();
    } else if (path.includes('plantillas-pagos')) {
      this.entity = 'PLANTILLA_PAGOS';
      this.resolveEntityLabels();
    } else if (path.includes('estructuras')) {
      this.entity = 'ESTRUCTURA';
      this.resolveEntityLabels();
    } else if (path.includes('areas')) {
      this.entity = 'AREA';
      this.resolveEntityLabels();
    } else if (path.includes('actividades')) {
      this.entity = 'ACTIVIDAD';
      this.resolveEntityLabels();
    } else if (path.includes('cantidades') || path.includes('medidas_cantidad')) {
      this.entity = 'CANTIDAD';
      this.resolveEntityLabels();
    } else if (path.includes('unidades') || path.includes('medidas_unidad')) {
      this.entity = 'UNIDAD';
      this.resolveEntityLabels();
    } else if (path.includes('subcontratistas')) {
      this.entity = 'SUBCONTRATISTA';
      this.resolveEntityLabels();
    } else if (path.includes('comercios')) {
      this.entity = 'COMERCIO';
      this.resolveEntityLabels();
    } else if (path.includes('categorias-gastos')) {
      this.entity = 'GASTO_CATEGORIA';
      this.resolveEntityLabels();
    }
  }

  async loadData() {
    this.loading = true;

    if (['PLANTILLA_OBS', 'PLANTILLA_PAGOS', 'COMERCIO', 'GASTO_CATEGORIA', 'CANTIDAD', 'UNIDAD', 'ACTIVIDAD'].includes(this.entity)) {
      const paramName = this.getJsonParamName();
      this.javapi.getJsonParam(paramName).subscribe({
        next: (res: any) => {
          this.loading = false;
          let dataList: any[] = [];
          const jsonContent = res.pa_json || res.dt3;
          if (res && jsonContent) {
            dataList = typeof jsonContent === 'string' ? JSON.parse(jsonContent) : jsonContent;
          }

          if (this.entity === 'PLANTILLA_OBS' || this.entity === 'PLANTILLA_PAGOS') {
            this.items = dataList.map((tmpl: any, index: number) => {
              const title = typeof tmpl === 'string' ? 'Sin título' : (tmpl.titulo || 'Sin título');
              const text = typeof tmpl === 'string' ? tmpl : (tmpl.texto || '');
              return {
                dt1: index.toString(),
                dt2: title, dt3: text,
                dt4: '', dt5: '', dt6: '', dt7: '', dt8: '', dt9: '', dt10: '',
                dt11: '', dt12: '', dt13: '', dt14: '', dt15: ''
              } as Modelogeneraldatos;
            });
          } else {
            this.items = dataList.map((item: any, index: number) => {
              if (this.entity === 'CANTIDAD') {
                return {
                  dt1: index.toString(),
                  dt2: item.nombre || item,
                  dt3: item.abreviatura || '',
                  dt4: '', dt5: '', dt6: '', dt7: '', dt8: '', dt9: '', dt10: '',
                  dt11: '', dt12: '', dt13: '', dt14: '', dt15: ''
                } as Modelogeneraldatos;
              }
              if (this.entity === 'UNIDAD') {
                return {
                  dt1: index.toString(),
                  dt2: item, // item is a string
                  dt3: '', dt4: '', dt5: '', dt6: '', dt7: '', dt8: '', dt9: '', dt10: '',
                  dt11: '', dt12: '', dt13: '', dt14: '', dt15: ''
                } as Modelogeneraldatos;
              }
              return {
                dt1: (item.id || index).toString(),
                dt2: item.nombre || item,
                dt3: '', dt4: '', dt5: '', dt6: '', dt7: '', dt8: '', dt9: '', dt10: '',
                dt11: '', dt12: '', dt13: '', dt14: '', dt15: ''
              } as Modelogeneraldatos;
            });
          }
          this.filteredItems = [...this.items];
          this.setupFields();
        },
        error: (err: any) => {
          console.error(err);
          this.loading = false;
          this.showToast('Error al cargar datos', 'danger');
        }
      });
      return;
    }

    this.javapi.executeAdminCrud(this.entity, 'SELECT_ALL', { dt1: '' }).subscribe({
      next: (res: Modelogeneraldatos[]) => {
        if (this.entity === 'SOLICITANTE') {
          this.rawSolicitorsList = res;
          const groupedMap = new Map<string, Modelogeneraldatos>();
          for (const item of res) {
            if (!groupedMap.has(item.dt1)) {
              groupedMap.set(item.dt1, { ...item });
            } else {
              const existing = groupedMap.get(item.dt1)!;
              if (item.dt13 && existing.dt13 && !existing.dt13.includes(item.dt13)) {
                existing.dt13 = `${existing.dt13}, ${item.dt13}`;
              }
            }
          }
          this.items = Array.from(groupedMap.values());
        } else {
          this.items = res;
        }
        this.items.sort((a, b) => (this.getName(a) || '').localeCompare(this.getName(b) || ''));
        this.filteredItems = [...this.items];
        this.loading = false;
        this.setupFields(); // Refresh field options if they depend on data
      },
      error: (err: any) => {
        console.error(err);
        this.loading = false;
        this.showToast('Error al cargar datos', 'danger');
      }
    });
  }

  getSolicitanteClients(solicitanteId: string): { id: number; nombre: string }[] {
    if (!solicitanteId) return [];
    return this.rawSolicitorsList
      .filter(s => s.dt1 === solicitanteId && Number(s.dt6) > 0)
      .map(s => ({ id: Number(s.dt6), nombre: s.dt13 || 'Cliente ' + s.dt6 }));
  }

  unlinkClient(solicitanteId: string, clienteId: number) {
    if (!solicitanteId || !clienteId) return;
    this.javapi.executeAdminCrud('SOLICITANTE', 'UNLINK_CLIENTE', {
      dt1: solicitanteId,
      dt6: clienteId.toString()
    }).subscribe({
      next: () => {
        this.rawSolicitorsList = this.rawSolicitorsList.filter(
          s => !(s.dt1 === solicitanteId && Number(s.dt6) === clienteId)
        );
        this.showToast('Cliente desvinculado', 'success');
        this.loadData();
      },
      error: () => {
        this.showToast('Error al desvincular cliente', 'danger');
      }
    });
  }

  loadAuxiliaryData() {
    // Load clients, groups, regions for selects if needed
    if (['DIRECCION', 'GRUPO', 'SOLICITANTE'].includes(this.entity)) {
      this.javapi.executeAdminCrud('CLIENTE', 'SELECT_ALL', { dt1: '' }).subscribe((res: any) => { this.clients = res; this.setupFields(); });
    }
    if (['DIRECCION', 'SOLICITANTE'].includes(this.entity)) {
      this.javapi.executeAdminCrud('GRUPO', 'SELECT_ALL', { dt1: '' }).subscribe((res: any) => { this.groups = res; this.setupFields(); });
    }
    if (['CLIENTE', 'DIRECCION'].includes(this.entity)) {
      this.javapi.executeAdminCrud('REGION', 'SELECT_ALL', { dt1: '' }).subscribe((res: any) => { this.regions = res; this.setupFields(); });
    }
    if (this.entity === 'TRABAJADOR') {
      this.javapi.executeAdminCrud('ROL', 'SELECT_ALL', { dt1: '' }).subscribe((res: any) => { this.roles = res; this.setupFields(); });
    }
    if (this.entity === 'GRUPO') {
      this.javapi.executeAdminCrud('SOLICITANTE', 'SELECT_ALL', { dt1: '' }).subscribe((res: any) => { this.solicitors = res; this.setupFields(); });
    }
  }

  setupFields() {
    const clientOpts = this.clients.map(c => ({ val: c.dt1, text: c.dt2 }));
    const groupOpts = this.groups.map(g => ({ val: g.dt1, text: g.dt3 }));
    const regionOpts = this.regions.map(r => ({ val: r.dt1, text: r.dt2 }));
    const roleOpts = this.roles.map(r => ({ val: r.dt1, text: r.dt2 }));

    switch (this.entity) {
      case 'CLIENTE':
        this.entityFields = [
          { key: 'dt2', label: 'Nombre', type: 'text' },
          { key: 'dt3', label: 'Región Principal', type: 'select', options: regionOpts }
        ];
        break;
      case 'DIRECCION':
        this.entityFields = [
          { key: 'dt2', label: 'Cliente', type: 'select', options: clientOpts },
          { key: 'dt3', label: 'Grupo de Notificación', type: 'select', options: groupOpts },
          { key: 'dt4', label: 'Región Combustible', type: 'select', options: regionOpts },
          { key: 'dt5', label: 'Nombre Lugar', type: 'text' }
        ];
        break;
      case 'SOLICITANTE':
        this.entityFields = [
          { key: 'dt6', label: 'Vincular Cliente', type: 'select', options: clientOpts },
          { key: 'dt2', label: 'Nombre', type: 'text' },
          { key: 'dt3', label: 'Grupo de Notificación', type: 'select', options: groupOpts },
          { key: 'dt5', label: 'Correo', type: 'text' }
        ];
        break;
      case 'GRUPO':
        this.entityFields = [
          { key: 'dt2', label: 'Cliente', type: 'select', options: clientOpts },
          { key: 'dt3', label: 'Nombre Grupo', type: 'text' },
          { key: 'dt4', label: 'Correo Grupo', type: 'text' },
          { key: 'dt5', label: 'Activo (A/I)', type: 'text' }
        ];
        break;
      case 'REGION':
        this.entityFields = [
          { key: 'dt2', label: 'Nombre Región', type: 'text' },
          { key: 'dt3', label: 'Costo Combustible', type: 'number' },
          { key: 'dt4', label: 'Activo (A/I)', type: 'text' }
        ];
        break;
      case 'ROL':
        this.entityFields = [
          { key: 'dt2', label: 'Nombre Rol', type: 'text' },
          { key: 'dt3', label: 'Costo Día', type: 'number' },
          { key: 'dt4', label: 'Costo Noche', type: 'number' }
        ];
        break;
      case 'TRABAJADOR':
        this.entityFields = [
          { key: 'dt3', label: 'Nombre', type: 'text' },
          { key: 'dt2', label: 'Cédula', type: 'text' },
          { key: 'dt4', label: 'Alias', type: 'text' },
          { key: 'dt6', label: 'Correo', type: 'text' },
          { key: 'dt8', label: 'Teléfono', type: 'text' },
          { key: 'dt9', label: 'Rol', type: 'select', options: roleOpts },
          { key: 'dt7', label: 'Dirección', type: 'text' }
        ];
        break;
      case 'SUBCONTRATISTA':
        this.entityFields = [
          { key: 'dt2', label: 'Nombre Subcontratista', type: 'text' }
        ];
        break;
      case 'ESTRUCTURA':
        this.entityFields = [
          { key: 'dt2', label: 'Nombre Estructura', type: 'text' }
        ];
        break;
      case 'AREA':
        this.entityFields = [
          { key: 'dt2', label: 'Nombre Área', type: 'text' }
        ];
        break;
      case 'ACTIVIDAD':
        this.entityFields = [
          { key: 'dt2', label: 'Descripción Actividad', type: 'text' }
        ];
        break;
      case 'CANTIDAD':
        this.entityFields = [
          { key: 'dt2', label: 'Nombre Cantidad', type: 'text' },
          { key: 'dt3', label: 'Abreviatura', type: 'text' }
        ];
        break;
      case 'UNIDAD':
        this.entityFields = [
          { key: 'dt2', label: 'Nombre Unidad', type: 'text' }
        ];
        break;
      case 'PLANTILLA_OBS':
      case 'PLANTILLA_PAGOS':
        this.entityFields = [
          { key: 'dt2', label: 'Título/Nombre', type: 'text', placeholder: 'Ej: Pago Semanal, Adelanto...' },
          { key: 'dt3', label: 'Texto de la Plantilla', type: 'textarea', placeholder: 'Texto que se insertará en el comentario...' }
        ];
        break;
      case 'COMERCIO':
        this.entityFields = [
          { key: 'dt2', label: 'Nombre Comercio', type: 'text' }
        ];
        break;
      case 'GASTO_CATEGORIA':
        this.entityFields = [
          { key: 'dt2', label: 'Nombre Categoría', type: 'text' }
        ];
        break;
      case 'ESTRUCTURA':
        this.entityFields = [
          { key: 'dt2', label: 'Nombre Estructura', type: 'text' }
        ];
        break;
      case 'AREA':
        this.entityFields = [
          { key: 'dt2', label: 'Nombre Área', type: 'text' }
        ];
        break;
    }
  }

  getFilteredGroups() {
    // For DIRECCION, client is in dt2; for SOLICITANTE, client is in dt6
    const clientId = this.entity === 'SOLICITANTE' ? this.currentData.dt6 : this.currentData.dt2;
    if (!clientId) return [];
    // GRUPO metadata: dt1: id, dt2: id_cliente, dt3: nombre
    return this.groups
      .filter(g => g.dt2 === clientId)
      .map(g => ({ val: g.dt1, text: g.dt3 }));
  }

  getName(item: Modelogeneraldatos) {
    switch (this.entity) {
      case 'DIRECCION': return item.dt5;
      case 'GRUPO': return item.dt3;
      case 'TRABAJADOR': return item.dt3;
      case 'PLANTILLA_OBS':
      case 'PLANTILLA_PAGOS': return item.dt2;
      default: return item.dt2;
    }
  }

  getDetail(item: Modelogeneraldatos) {
    switch (this.entity) {
      case 'CLIENTE': return item.dt4 || 'Sin región';
      case 'DIRECCION':
        const groupInfo = item.dt7 ? ` [${item.dt7}]` : '';
        return `${item.dt6 || 'Sin cliente'} • ${item.dt8 || 'Sin región'}${groupInfo}`;
      case 'SOLICITANTE': return `${item.dt5 || 'Sin correo'} • ${item.dt12 || 'Sin grupo'}`;
      case 'GRUPO': return `${item.dt6 || 'Sin cliente'} • ${item.dt4}`;
      case 'REGION': return `$${item.dt3} combustible`;
      case 'ROL': return `Día: $${item.dt3 || '0.00'} • Noche: $${item.dt4 || '0.00'}`;
      case 'TRABAJADOR': return `${item.dt2 || 'Sin cédula'} • ${item.dt6 || 'Sin correo'}`;
      case 'PLANTILLA_OBS':
      case 'PLANTILLA_PAGOS': return (item.dt3 || '').substring(0, 50) + '...';
      case 'CANTIDAD': return item.dt3;
      default: return '';
    }
  }

  getFieldIcon(label: string): string {
    if (!label) return 'information-circle-outline';
    const l = label.toLowerCase();
    if (l.includes('nombre') || l.includes('cliente') || l.includes('solicitante')) return 'person-outline';
    if (l.includes('correo') || l.includes('email')) return 'mail-outline';
    if (l.includes('teléfono') || l.includes('celular')) return 'call-outline';
    if (l.includes('título')) return 'bookmark-outline';
    if (l.includes('texto') || l.includes('descripción') || l.includes('observación')) return 'document-text-outline';
    if (l.includes('costo') || l.includes('valor') || l.includes('precio')) return 'cash-outline';
    if (l.includes('dirección') || l.includes('sucursal') || l.includes('lugar')) return 'location-outline';
    if (l.includes('rol')) return 'briefcase-outline';
    if (l.includes('activo')) return 'power-outline';
    if (l.includes('grupo') || l.includes('notificación')) return 'people-outline';
    if (l.includes('región')) return 'map-outline';
    if (l.includes('unidad')) return 'thermometer-outline';
    if (l.includes('cantidad')) return 'calculator-outline';
    return 'information-circle-outline';
  }

  /**
   * Returns a secondary detail line for entities that need it.
   * Currently used for SOLICITANTE to show the associated client.
   */
  getSubDetail(item: Modelogeneraldatos): string {
    switch (this.entity) {
      case 'SOLICITANTE': return item.dt13 || '';
      case 'TRABAJADOR':
        if (this.roles && this.roles.length > 0) {
          const role = this.roles.find(r => String(r.dt1) === String(item.dt9));
          if (role) return role.dt2; // Retornar el nombre del rol (dt2)
        }
        return item.dt10 && !item.dt10.includes('-') ? item.dt10 : 'Sin rol';
      default: return '';
    }
  }

  /**
   * Returns solicitors associated with a given group.
   */
  getSolicitorsByGroup(groupId: string): Modelogeneraldatos[] {
    if (!groupId || this.entity !== 'GRUPO') return [];
    return this.solicitors.filter(s => s.dt3 === groupId);
  }

  filterItems() {
    if (!this.searchText) {
      this.filteredItems = [...this.items];
      return;
    }
    const search = this.searchText.toLowerCase();
    this.filteredItems = this.items.filter(item =>
      item.dt2?.toLowerCase().includes(search) ||
      item.dt3?.toLowerCase().includes(search) ||
      item.dt4?.toLowerCase().includes(search) ||
      item.dt5?.toLowerCase().includes(search)
    );
  }

  async openAddModal() {
    this.setupFields();
    const modal = await this.modalCtrl.create({
      component: AdminCrudEditModalComponent,
      componentProps: {
        entity: this.entity,
        entityName: this.entityName,
        iconName: this.iconName,
        iconColor: this.iconColor,
        isEditing: false,
        item: { dt1: '0', dt4: 'V', ...this.initialData },
        entityFields: this.entityFields,
        groups: this.groups,
        rawSolicitorsList: this.rawSolicitorsList,
        allItems: this.items
      },
      backdropDismiss: false
    });
    await modal.present();

    const { data } = await modal.onWillDismiss();
    if (data?.updated) {
      this.loadData();
      if (this.isModal && data.insertedData) {
        setTimeout(() => {
          this.modalCtrl.dismiss(data.insertedData);
        }, 200);
      }
    } else if (data?.deleted) {
      this.loadData();
    }
  }

  async openEditModal(item: Modelogeneraldatos) {
    this.setupFields();
    const modal = await this.modalCtrl.create({
      component: AdminCrudEditModalComponent,
      componentProps: {
        entity: this.entity,
        entityName: this.entityName,
        iconName: this.iconName,
        iconColor: this.iconColor,
        isEditing: true,
        item: { ...item },
        entityFields: this.entityFields,
        groups: this.groups,
        rawSolicitorsList: this.rawSolicitorsList,
        allItems: this.items
      },
      backdropDismiss: false
    });
    await modal.present();

    const { data } = await modal.onWillDismiss();
    if (data?.updated || data?.deleted) {
      this.loadData();
    }
  }

  closeModal() {
    this.isModalOpen = false;
  }

  closeMainModal() {
    this.modalCtrl.dismiss();
  }

  closePage() {
    if (this.isModal) {
      this.closeMainModal();
    } else {
      this.navCtrl.back();
    }
  }

  confirmDeleteDirect(item: Modelogeneraldatos, event: Event) {
    event.stopPropagation();
    this.confirmDelete(item);
  }

  async confirmDelete(item: Modelogeneraldatos) {
    const name = this.getName(item);
    const alert = await this.alertCtrl.create({
      header: 'Confirmar eliminación',
      subHeader: this.entityLabel,
      message: `¿Estás seguro de eliminar el registro "${name}"? Esta acción no se puede deshacer.`,
      cssClass: 'custom-alert',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'alert-button btn-cancel'
        },
        {
          text: 'Eliminar',
          role: 'destructive',
          cssClass: 'danger-btn',
          handler: () => {
            this.deleteItem(item);
          }
        }
      ]
    });
    await alert.present();
  }

  deleteItem(item: Modelogeneraldatos) {
    this.loading = true;

    if (['PLANTILLA_OBS', 'PLANTILLA_PAGOS', 'COMERCIO', 'GASTO_CATEGORIA', 'ACTIVIDAD', 'CANTIDAD', 'UNIDAD'].includes(this.entity)) {
      const paramName = this.getJsonParamName();
      let dataList: any[] = [];

      if (this.entity === 'PLANTILLA_OBS' || this.entity === 'PLANTILLA_PAGOS') {
        dataList = this.items.filter(i => i.dt1 !== item.dt1).map(i => ({ titulo: i.dt2, texto: i.dt3 }));
      } else if (this.entity === 'CANTIDAD') {
        dataList = this.items.filter(i => i.dt1 !== item.dt1).map(i => ({ nombre: i.dt2, abreviatura: i.dt3 }));
      } else if (this.entity === 'UNIDAD') {
        dataList = this.items.filter(i => i.dt1 !== item.dt1).map(i => i.dt2);
      } else {
        dataList = this.items.filter(i => i.dt1 !== item.dt1).map(i => ({ id: i.dt1, nombre: i.dt2 }));
      }

      this.javapi.saveJsonParam(paramName, JSON.stringify(dataList)).subscribe({
        next: () => {
          this.loading = false;
          this.showToast('Eliminado exitosamente', 'success');
          this.closeModal();
          this.loadData();
        },
        error: (err: any) => {
          this.loading = false;
          this.showToast('Error al eliminar', 'danger');
        }
      });
      return;
    }

    this.javapi.executeAdminCrud(this.entity, 'DELETE', { dt1: item.dt1 }).subscribe({
      next: () => {
        this.loading = false;
        this.showToast('Eliminado exitosamente', 'success');
        this.closeModal();
        this.loadData();
      },
      error: (err: any) => {
        this.loading = false;
        this.showToast('Error al eliminar', 'danger');
      }
    });
  }

  private getJsonParamName(): string {
    switch (this.entity) {
      case 'PLANTILLA_OBS': return 'CT_OBS_COTIZACIONES';
      case 'PLANTILLA_PAGOS': return 'CT_PLANILLA_PAGOS';
      case 'COMERCIO': return 'fe_lista_comercios';
      case 'GASTO_CATEGORIA': return 'fe_lista_categorias_gastos';
      case 'ACTIVIDAD': return 'fe_lista_actividades';
      case 'CANTIDAD': return 'fe_lista_cantidades';
      case 'UNIDAD': return 'fe_lista_unidades';
      default: return '';
    }
  }

  async showToast(message: string, color: string = 'success') {
    const toast = await this.toastCtrl.create({
      message,
      duration: 2000,
      color,
      position: 'top',
      cssClass: `premium-toast toast-${color}`
    });
    await toast.present();
  }
}
